module.exports = __webpack_public_path__ + "static/media/logo-outline.75722bf3.svg";